exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_view_cv{\n  width: 950px;\n  height: 85vh;\n  overflow-y: scroll !important;\n  margin: -12px;\n  padding: 0px;\n}\n\n.btn_close{\n  width: auto;\n  float: right;\n  margin-top: 20px;\n  margin-bottom: -31px;\n  z-index: 2;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-cv/view-cv.component.css
// module id = ../../../../../src/app/pages/view-cv/view-cv.component.css
// module chunks = main